import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { OrderLifeCycleEventImpl } from "../model/impl/OrderLifeCycleEventImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class OrderLifeCycleEventImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: OrderLifeCycleEventImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.targetUserCode != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(1),
        false,
        encodable.targetUserCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.externalClientReference != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(3),
        false,
        encodable.externalClientReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.orderId != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(4),
        false,
        encodable.orderId,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyId != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(5),
        false,
        encodable.strategyId,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.eventTypeId != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(6),
        false,
        encodable.eventTypeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.errors != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(7),
        true,
        encodable.errors,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyComponentState != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(8),
        false,
        encodable.strategyComponentState,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.fxOrderLifeCycleEvent != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(9),
        false,
        encodable.fxOrderLifeCycleEvent,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(10),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.strategyOrderState != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        true,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(11),
        false,
        encodable.strategyOrderState,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.orderData != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(12),
        true,
        encodable.orderData,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.linkReference != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(13),
        false,
        encodable.linkReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.rollbackEventFg != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(14),
        false,
        encodable.rollbackEventFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.rejectType != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(15),
        false,
        encodable.rejectType,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        OrderLifeCycleEventImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,OrderLifeCycleEventImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "com.bcdfx.api.event.FxLifeCycleEventType"],
    [7, "com.bcdfx.model.Errors"],
    [8, "com.bcdfx.model.StrategyComponentState"],
    [9, "com.bcdfx.api.event.FxLifeCycleEventType"],
    [10, "java.lang.String"],
    [11, "com.bcdfx.model.StrategyComponentState"],
    [12, "com.bcdfx.model.event.lifecycle.fx.OrderData"],
    [13, "java.lang.String"],
    [14, "java.lang.Boolean"],
    [15, "com.bcdfx.api.event.RejectSubType"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: OrderLifeCycleEventImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.targetUserCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.externalClientReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.orderId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.strategyId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.FxLifeCycleEventType = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.eventTypeId = <CubiqTS.FxLifeCycleEventType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(
            true,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.errors = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyComponentState> = this.baseEncoder.readObject(
            false,
            true,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.strategyComponentState = <Array<CubiqTS.StrategyComponentState>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.FxLifeCycleEventType = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.fxOrderLifeCycleEvent = <CubiqTS.FxLifeCycleEventType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.id = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: Array<CubiqTS.StrategyComponentState> = this.baseEncoder.readObject(
            false,
            true,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.strategyOrderState = <Array<CubiqTS.StrategyComponentState>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.OrderData = this.baseEncoder.readObject(
            true,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.orderData = <CubiqTS.OrderData>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.linkReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.rollbackEventFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.RejectSubType = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.rejectType = <CubiqTS.RejectSubType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            OrderLifeCycleEventImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,OrderLifeCycleEventImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return OrderLifeCycleEventImplEncoder.fidTypeMap.has(fid);
  }
}
